import type { ProductLabResult } from "@/domains/products/models/types";
import { Divider, Heading } from "@/ui";
import { CertificateOfAnalysisRow } from "./certificate-of-analysis-row";

type CertificateOfAnalysisTableProps = {
  certificatesOfAnalysis: ProductLabResult[];
};

export const CertificateOfAnalysisTable = ({
  certificatesOfAnalysis,
}: CertificateOfAnalysisTableProps) => {
  return (
    <div>
      <Heading level={1}>{`What's Inside, Verified (COAs)`}</Heading>
      <Divider.Line className="mt-8 mb-6" />
      <p className="sm:text-xl">
        We publish a Certificate of Analysis (COA) for every EO product. Each COA comes from a
        leading, independent lab and details both potency and safety testing.{" "}
      </p>

      <div>
        {certificatesOfAnalysis.map((labResult) => {
          return <CertificateOfAnalysisRow key={labResult.id} labResult={labResult} />;
        })}
      </div>
    </div>
  );
};
